function monthsToYearsFormatter(monthsInput) {
  const years = Math.floor(monthsInput/12);
  const months = monthsInput % 12;
  return `${years} years and ${months} months`
}

export default monthsToYearsFormatter;
